import React, { useState, useRef, useCallback, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Row, Col, NMForm, OutlinedButton, TextButton } from "@neumetric/blueprint-lib/components";
import { Collapse } from "antd";
import { useParams } from "react-router-dom";
import { getCurrentRisk, riskActions, isRiskAccepted, isRiskArchived } from "../../store";

const RiskAcceptanceFormFields = [
  {
    label: "Justification",
    attribute: "justification",
    typeRepresentation: "HTML",
    required: false,
    classes: { root: "w-100" },
    tooltip: "Justification Field",
  },
  {
    label: "Impact",
    attribute: "risk_impact",
    typeRepresentation: "HTML",
    required: false,
    classes: { root: "w-100" },
    tooltip: "Impact Field",
  },
  {
    label: "Compensating Controls",
    attribute: "compensating_controls",
    typeRepresentation: "HTML",
    required: false,
    classes: { root: "w-100" },
    tooltip: "Compensating Controls Field",
  },
];

export const RiskAcceptanceSection = forwardRef((props, ref) => {
  const { onShowReport } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const _ref = useRef(null);
  const { riskId } = useParams();
  const currentRisk = useSelector(getCurrentRisk);
  const isRiskAccept = useSelector(isRiskAccepted);
  const isRiskArchive = useSelector(isRiskArchived);

  const formInitialValues = React.useMemo(() => {
    if (riskId && currentRisk) {
      return {
        ...currentRisk,
      };
    }
    return {};
  }, [riskId, currentRisk]);

  const getModifiedFieldsComment = React.useCallback((fields) => {
    return fields.map((field) => `Updated ${field.label}.`).join("<br/>");
  }, []);

  const handleSave = () => {
    if (!_ref.current.validate()) {
      return;
    }
    let fields = _ref.current.getDirtyFields();
    if (fields.length === 0) {
      return;
    }
    setIsSubmitting(true);
    const values = _ref.current.getValues({ dirtyOnly: true });
    const comment = getModifiedFieldsComment(fields);
    const action = riskActions.updateRisk({ risk: values, comment: { comment: comment } });
    action.onComplete = () => {
      setIsSubmitting(false);
    };
    action.onFailure = () => {
      setIsSubmitting(false);
    };
    dispatch(action);
  };
  React.useImperativeHandle(ref, () => ({
    resetFormData: () => {
      _ref.current.resetFormData();
    },
  }));

  return (
    <Collapse className="w-100 mt-16" defaultActiveKey={["risk"]} collapsible="disabled">
      <Collapse.Panel
        key="risk"
        className=""
        showArrow={false}
        header={
          <Row align="center" justify="between" className="w-100">
            <span className="ff-exo2 fs-18 fw-600 line-28 text-filled">Risk Acceptance Information</span>
            <Button label="View Record" onClick={onShowReport} />
          </Row>
        }
      >
        <Col className="w-100">
          <NMForm
            ref={_ref}
            direction="vertical"
            className="flex-auto"
            readOnly={isRiskAccept || isRiskArchive}
            fields={RiskAcceptanceFormFields}
            formData={formInitialValues}
          />
          {!isRiskAccept && !isRiskArchive && (
            <Row align="center" justify="end" className="w-100">
              <Button label="Save" icon="SUBMIT" onClick={handleSave} loading={isSubmitting} />
            </Row>
          )}
        </Col>
      </Collapse.Panel>
    </Collapse>
  );
});
